module.exports = __webpack_public_path__ + "static/img/race2.d837b66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/race2.png
// module id = Vhhl
// module chunks = 1 3